<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Charger List" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col :class="$vuetify.display.width > 700 ? 'd-flex align-item-center px-2' : 'd-flex align-item-center px-0'" :span="24">
        <div :class="$vuetify.display.width > 700 ? 'row m-0 width-100-p px-2' : 'row m-0 width-100-p px-0'">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <!-- <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                            </template> -->
                            <el-option
                              v-for="(item, index) in search_by_dropdown[selectedTableTab]"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>


            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_user"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>

      <!-- Delete charger admin panel -->
      <el-col :class="$vuetify.display.width > 700 ? 'd-flex align-item-center mt-20 px-2' : 'd-flex align-item-center mt-20 px-0'" :span="24">
        <div :class="$vuetify.display.width > 700 ? 'row m-0 width-100-p px-2' : 'row m-0 width-100-p px-0'">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
          <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Charger Bulk Delete</h5>
              <span class="moderat-white-12 ml-1">
                * Use the bulk delete button in the Operations column to auto-fill customer and created at
              </span>
          </el-col>
              <!-- custom filter scenario 1 -->
              <!-- customer filter (admin only) & location filter & MP filter & custom date -->
              <div class="custom-filter-container pr-20">
                  <!-- Custom filter -->
                  <el-row >
                      <div 
                      class="custom-filter-container-wrapper d-flex row y-center m-0 mb-12 width-100-p"
                      >
                          <el-form :label-position="`top`" class="custom-filter-form d-flex">
                          <el-space
                              class="custom-filter-space"
                              fill
                              >
                              <el-row gutter="20">
                                <el-col 
                                    :span="$vuetify.display.width > 1280 ? 10 : 24" 
                                    :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                                      <el-form-item
                                            class="custom-filter-item label-style"
                                            prop="customer"
                                            label="Customer"
                                        >
                                            <!-- customer select -->
                                            <div>
                                              <el-tooltip
                                              effect="light"
                                              placement="top"
                                              show-after="500"
                                              hide-after="300"
                                              >
                                              <template #content > 
                                                  <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Delete for this customer" }} </span>
                                              </template>
                                                <el-select 
                                                    v-model="deleteFilter.customer_id" 
                                                    placeholder="Select Customer"  
                                                    class="custom-filter-select"
                                                    clearable
                                                    >
                                                    <el-option
                                                        v-for="item in customers"
                                                        :key="item.id"
                                                        :label="item.full_name"
                                                        :value="item.id"
                                                        >
                                                        <span>{{ item.full_name }}</span>
                                                        <!-- <span>{{ item.phone }}</span> -->
                                                    </el-option>
                                                </el-select>
                                                </el-tooltip>
                                            </div>
                                      </el-form-item>
                                </el-col>
                                <el-col 
                                :span="$vuetify.display.width > 1280 ? 10 : 24" 
                                :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center' ">
                                      <el-tooltip
                                              effect="light"
                                              placement="top"
                                              show-after="500"
                                              hide-after="300"
                                              >
                                              <template #content > 
                                                  <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Delete for this created at datetime" }} </span>
                                              </template>
                                      <el-form-item
                                          class="custom-filter-item"
                                          prop="datetime"
                                          label="Created at"
                                      >
                                          <!-- date range picker -->
                                          <div>
                                              <el-date-picker
                                                  class="custom-filter-date-picker-charger-delete"
                                                  v-model="deleteFilter.dateTime"
                                                  type="datetime"
                                                  placeholder="Pick a Date and Time"
                                                  range-separator="To"
                                                  format="YYYY-MM-DD HH:mm:ss.SSS"
                                                  value-format="x"
                                                  unlink-panels
                                                  disabled
                                                  @change="handleDateRangeChange"
                                                />

                                          </div>
                                      </el-form-item>
                                      </el-tooltip>
                                </el-col>
                              </el-row>
                          </el-space>
                          </el-form>
                          <el-row gutter="20" class="custom-filter-button-container float-right mb-20">
                              <el-col :span="24" :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'">
                                  <el-button
                                      v-if="showDeleteButton"
                                      @click="handleDeleteCharger"
                                      class="custom-filter-button-apply"
                                  >
                                  <svg class="width-112 height-40">
                                      <use
                                          href="@/assets/svg/newSvgIcon.svg#tableDeleteButton"
                                      ></use>
                                      </svg>
                                  </el-button>
                                  <el-button
                                      @click="resetFilter"
                                      class="custom-filter-button-reset"
                                  >
                                      <svg class="width-112 height-40">
                                      <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                                      </svg>
                                  </el-button>
                                  </el-col>
                          </el-row>
                      </div>
                  </el-row>
              </div>

              <DeleteTable 
              @tableAction="handleTableAction"
              :customerIdProp="deleteFilter.customer_id"
              :dateTimeFilterProp="deleteFilter.dateTime"
              :class="$vuetify.display.width >= 1400 ? 'my-30' : $vuetify.display.width >= 768 ? 'my-30' : $vuetify.display.width >= 375 ? 'my-24' : 'my-20'" />
          </div>
        </div>
      </el-col>
      <!-- Charger Date inconsistency admin panel -->
      <!-- <el-col :class="$vuetify.display.width > 700 ? 'd-flex align-item-center mt-20 px-2' : 'd-flex align-item-center mt-20 px-0'" :span="24">
        <div :class="$vuetify.display.width > 700 ? 'row m-0 width-100-p px-2' : 'row m-0 width-100-p px-0'">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Charger Info Inconsistency</h5>
              <span class="moderat-white-12 ml-1">
                * Check for chargers with information inconsistencies
              </span>
            </el-col>

              <div class="custom-filter-container pr-20">
             
                  <el-row >
                      <div 
                      class="custom-filter-container-wrapper d-flex row y-center m-0 mb-12 width-100-p"
                      >
                          <el-form :label-position="`top`" class="custom-filter-form d-flex">
                          <el-space
                              class="custom-filter-space"
                              fill
                              >
                              <el-row gutter="20">
                                <el-col 
                                    :span="$vuetify.display.width > 1280 ? 10 : 24" 
                                    :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                                      <el-form-item
                                            class="custom-filter-item label-style"
                                            prop="customer"
                                            label="Customer"
                                        >
                                       
                                            <div>
                                              <el-tooltip
                                              effect="light"
                                              placement="top"
                                              show-after="500"
                                              hide-after="300"
                                              >
                                              <template #content > 
                                                  <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select customer to check for charger info inconsistency" }} </span>
                                              </template>
                                                <el-select 
                                                    v-model="dateInconsistencyFilter.customer_id" 
                                                    placeholder="Select Customer"  
                                                    class="custom-filter-select"
                                                    clearable
                                                    >
                                                    <el-option
                                                        v-for="item in customers"
                                                        :key="item.id"
                                                        :label="item.full_name"
                                                        :value="item.id"
                                                        >
                                                        <span>{{ item.full_name }}</span>
                                                  
                                                    </el-option>
                                                </el-select>
                                                </el-tooltip>
                                            </div>
                                      </el-form-item>
                                </el-col>
                              </el-row>
                          </el-space>
                          </el-form>
                      </div>
                  </el-row>
              </div>
              <ChargerDateInconsisTable
              @tableAction="handleTableAction"
              :customerIdProp="dateInconsistencyFilter.customer_id"
              :class="$vuetify.display.width >= 1400 ? 'my-30' : $vuetify.display.width >= 768 ? 'my-30' : $vuetify.display.width >= 375 ? 'my-24' : 'my-20'"
              />
          </div>
        </div>
       </el-col> -->
    </el-row>
  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
import DeleteTable from "./deleteTable.vue";
// import ChargerDateInconsisTable from "./chargerDateInconsisTable.vue";
// import Filter from "./filter.vue";
// import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { convertToTitleCase, shorterLabel } from "../dashboard/common/common-tools"
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "users",
  components: {
    Breadcrumbs,
    DataTable,
    DeleteTable,
    // ChargerDateInconsisTable,
    // Filter,
    // ShowDetail,
  },
  data() {
    return {
      search_by_dropdown: {
        charging_sites: ['customer', 'site_name', 'charger_id', 'port_id', 'country', 'state', 'city', 'street_name', 'suburb', 'postcode', 'address_comment', 'elec_region'],
      },
      selectedSearchBy: 'site_name',
      selectedTableTab: 'charging_sites',

      breadcrumbPath: [
        {
          title: "Operation",
          disabled: true,
          href: "",
        },
        {
          title: "Charger List",
          disabled: false,
          href: "/charging-sites",
          active: true,
        },
      ],

      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,

      // delete charger admin panel
      showDeleteButton: false,
      customers: [],
      tempDateTime: null,
      dateTime: null,
      deleteFilter: {
        customer_id: null,
        dateTime: null,
        option: null,
      },
      dateInconsistencyFilter: {
        customer_id: null,
      },
    };
  },
  watch: {
    'deleteFilter.customer_id': function (newValue) {
      // Convert empty string to null when customer is cleared
      if (newValue === '') {
          this.deleteFilter.customer_id = null;
      }
    },

    'dateInconsistencyFilter.customer_id': function (newValue) {
      // Convert empty string to null when customer is cleared
      if (newValue === '') {
          this.dateInconsistencyFilter.customer_id = null;
      }
    },

    'deleteFilter': {
      handler: function (newValue) {
        // console.log('newValue', newValue);
        if (newValue.customer_id && newValue.dateTime 
        && newValue.customer_id != null && newValue.dateTime != null && newValue.option != null
        && newValue.customer_id != '' && newValue.dateTime != '' && newValue.option != '') {
          this.showDeleteButton = true;
        } else {
          this.showDeleteButton = false;
        }
      },
      deep: true,
      immediate: true,
    }

  },
  computed: {
    filter_user() {
      return this.userDataList;
    },
  },
  mounted() {
    this.fetchChargingData(this.current_page);

    if (
            this.$store.state.auth.user != null &&
            this.$store.state.auth.user.is_admin
        ) {
            this.fetchCustomerData();
        }
  },
  methods: {
    convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },

    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
      // console.log('selected search by', this.selectedSearchBy);
    },


    changePage(page) {
      this.fetchChargingData(page);
    },
    fetchChargingData(page) {
      UserService.getChargingSites(null, this.search, page, this.perPageCount, null, this.selectedSearchBy)
        .then(
          (response) => {
            this.userDataList = response.data.charging_sites;
            this.total_items = response.data.total_record;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    DeleteChargerSite(event, index) {
      UserService.deleteChargingSite(event.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.userDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.userDataList.length == this.current_row_index)
        this.userDataList.push(event);
      else this.userDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    handleUpdate(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.$router.replace({
        path: "/charging-sites-detail",
        // query: { supportData: this.data_modal },
        query: { charging_site_id: data.id },
      });
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async handleExportFile() {
      await UserService.getChargingSites(null, this.search, 1, 50, null, "", true).then(
        async (response) => {
        let dataList = response.data.charging_sites;
        
        if (dataList.length > 0) {
          const skipKeys = ["id", "customer_id", "phone", "description", "lat", "lng", "state", "city", "suburb", "street_number", "street_name", "created_at", "updated_at", "address_comment"]; // Keys to skip
          const fileName = "ChargerList.xlsx"; // File name
          const newWorksheetName = "Charger List"; // Worksheet name
          const title = "Charger List"; // Title for the Excel file

          try {
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch(error) {
          console.log("error when export excel", error.message);
          
        }
          } else {
            console.log("empty data list");
          }
      })

    },

    // handleExportFile() {
    //   if (this.filter_user.length > 0) {
    //     const myHeader = [];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_user, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "ChargingSiteList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    filterAction(event) {
      if (event.kind == "excel") {
        this.handleExportFile();
      } else if (event.kind == "reload") {
        this.handleReload();
      } else if (event.kind == "new") {
        this.handleNew();
      }
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        // this.handleShow(event.index, event.data);
        this.handleUpdate(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchChargingData(this.current_page);
      } else if (event.kind == "perPageChange") { 
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      } else if (event.kind == "copyCreateAt") {
        this.pasteCreateAt(event.created_at, event.customer_id, event.option);
      } else if (event.kind == "resetElecRegionDone") {
        this.fetchChargingData(this.current_page);
      }
    },

    handleReload() {
      this.current_page = 1;
      this.fetchChargingData(this.current_page);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        is_active: true,
        customer_id: null,
        id: 0,
      };
      this.current_row_index = this.userDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    
    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteChargerSite(event, index);
        })
        .catch(() => {});
    },

    // ===== delete charger group =====
    // fetch customer data
    async fetchCustomerData() {
            this.loading = true;
            await UserService.getCustomers(null)
                .then(
                (response) => {
                    if (!response || !response.data || !response.data.customers) {
                        this.customers = [];
                    } else {
                        this.customers = response.data.customers;
                    }
                },
                (error) => {
                    this.loading = false;
                    console.log(error.message);
                    if (error.response.status == 401) {
                    this.$router.push({
                        path: "/",
                    });
                    }
                }
                )
                .catch((error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response.status == 401) {
                    this.$router.push({
                    path: "/",
                    });
                }
                })
                .finally(() => (this.loading = false));
    },

    handleDateRangeChange(value) {
      // console.log('value', value);
      this.deleteFilter.dateTime = value;
    },

    pasteCreateAt(created_at, customer_id, delete_option) {
      // console.log('created_at', created_at);
      // console.log('customer_id', customer_id);
      this.deleteFilter.dateTime = created_at;
      this.deleteFilter.customer_id = customer_id;
      this.deleteFilter.option = delete_option;
    },

    resetFilter() {
      this.tempDateTime = null;
      this.deleteFilter.dateTime = null;
      this.deleteFilter.customer_id = null;
      this.deleteFilter.option = null;
    },

    // send delete request
    handleDeleteCharger() {
      // console.log('deleteFilter', this.deleteFilter);

      // Get customer name from customer_id
      const customer = this.customers.find(c => c.id === this.deleteFilter.customer_id);
      const customerName = customer ? customer.full_name : 'Unknown Customer';
      
      let MessageBox = `<span class="moderat-meGreen-bold">Do you want to proceed with bulk deleting charging sites, chargers, and ports for:</span>
        <br> <span class="moderat-meGreen-bold">Delete Option:</span> ${this.deleteFilter.option.toUpperCase()}
        <br> <span class="moderat-meGreen-bold">Customer:</span> ${customerName} 
        <br> <span class="moderat-meGreen-bold">Created at:</span> ${this.deleteFilter.dateTime.replace('T', ' ')}  
        <br> <span class="moderat-meGreen-bold">This action cannot be undone!</span>`;
              return ElMessageBox.confirm(
                MessageBox,
                "Confirm Bulk Delete",
                {
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                  type: "confirm",
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                this.submitDelete();

              }
              ).catch(() => {
                console.log("Delete cancelled");
              });
    },

    async submitDelete() {
      await UserService.deleteChargerAdminPanel(this.deleteFilter)
        .then(
          (response) => {
            if (response.data.code === 1000 && response.data.status === "success") {
              // this.$message.success("Bulk delete successful");
              let result = response.data.data;
              let port_result = '';
              let charger_result = '';
              let site_result = '';
              let message = '';
              if (this.deleteFilter.option == "all") {
                 port_result = result.ports_result.message ? result.ports_result.message : '';
                 charger_result = result.chargers_result.message ? result.chargers_result.message : '';
                 site_result = result.sites_result.message ? result.sites_result.message : '';
                 message = `<span class="moderat-meGreen-bold">Deleting results:</span>
              <br> <span class="moderat-meGreen-bold">Port:</span> ${port_result} 
              <br> <span class="moderat-meGreen-bold">Charger:</span> ${charger_result} 
              <br> <span class="moderat-meGreen-bold">Site:</span> ${site_result}`;
              }

              if (this.deleteFilter.option == "site") {
                site_result = result.sites_result.message ? result.sites_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
              <br> <span class="moderat-meGreen-bold">Site:</span> ${site_result}`;
              }

              if (this.deleteFilter.option == "charger") {
                charger_result = result.chargers_result.message ? result.chargers_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
                <br> <span class="moderat-meGreen-bold">Charger:</span> ${charger_result}`;
              }

              if (this.deleteFilter.option == "port") {
                port_result = result.ports_result.message ? result.ports_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
                <br> <span class="moderat-meGreen-bold">Port:</span> ${port_result}`;
              }
              
              let MessageBox = message;

              return ElMessageBox.confirm(
                MessageBox,
                "Bulk Delete Successful",
                {
                  confirmButtonText: "OK",
                  type: "success",
                  dangerouslyUseHTMLString: true,
                  showCancelButton: false,
                }
              ).catch(() => {
                console.log("Delete cancelled");
              }).finally(() => {
                this.resetFilter();
                this.handleReload();
              });
            } else if (response.data.code === 1000 && response.data.status === "error") {

              let result = response.data.data;
              let port_result = '';
              let charger_result = '';
              let site_result = '';
              let message = '';
              if (this.deleteFilter.option == "all") {
                 port_result = result.ports_result.message ? result.ports_result.message : '';
                 charger_result = result.chargers_result.message ? result.chargers_result.message : '';
                 site_result = result.sites_result.message ? result.sites_result.message : '';
                 message = `<span class="moderat-meGreen-bold">Deleting results:</span>
              <br> <span class="moderat-meGreen-bold">Port:</span> ${port_result} 
              <br> <span class="moderat-meGreen-bold">Charger:</span> ${charger_result} 
              <br> <span class="moderat-meGreen-bold">Site:</span> ${site_result}
              <br> <span class="moderat-meGreen-bold">Please remove dependency and try again.</span>`;
              }

              if (this.deleteFilter.option == "site") {
                site_result = result.sites_result.message ? result.sites_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
              <br> <span class="moderat-meGreen-bold">Site:</span> ${site_result}
              <br> <span class="moderat-meGreen-bold">Please remove dependency and try again.</span>`;
              }

              if (this.deleteFilter.option == "charger") {
                charger_result = result.chargers_result.message ? result.chargers_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
                <br> <span class="moderat-meGreen-bold">Charger:</span> ${charger_result}
                <br> <span class="moderat-meGreen-bold">Please remove dependency and try again.</span>`;
              }

              if (this.deleteFilter.option == "port") {
                port_result = result.ports_result.message ? result.ports_result.message : '';
                message = `<span class="moderat-meGreen-bold">Deleting results:</span>
                <br> <span class="moderat-meGreen-bold">Port:</span> ${port_result}
                <br> <span class="moderat-meGreen-bold">Please remove dependency and try again.</span>`;
              }

              let MessageBox = message;
              
              return ElMessageBox.confirm(
                MessageBox,
                "Bulk Delete Failed",
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                  showCancelButton: false,
                }
              ).catch(() => {
                console.log("Delete cancelled");
              }).finally(() => {
                this.resetFilter();
                this.handleReload();
              });
            } else {
                console.log('response.data.message', response.data.message);
            }
          }
        ).catch((error) => {
          console.log(error.message);
          if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
        })
        .finally(() => {
          
        });
    },
    // ===== delete charger group =====

  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
